 
import React from "react";
import {
  IDataTableV2DetailColumn,
  IDataTableV2FormattedData,
  IDataTableV2GroupBy,
  IDataTableV2Row,
} from "../interfaces/IDataTableV2Props";
import { prepareDataToDataTableV2Format, tableV2DataSorting } from "../helpers";
import { ISortingConfig } from "../../Table/interfaces/IDataTableProps";
import { IDataTableV2SelectAllCheckedType } from "../components/DataTableV2SelectAll/interfaces/IDataTableV2SelectAllProps";

export const useTableV2 = (
    uniqueRowKeyName: string,
  rows: IDataTableV2Row[],
  sortingConfig: ISortingConfig,
  groupBy?: IDataTableV2GroupBy,
  detailColumns?: IDataTableV2DetailColumn[],
  controlledSelectedRows: any[] = [],
    onSelection?: (isAllSelected: boolean, selectedRows: any) => void,
) => {
  const [originalRows, setOriginalRows] = React.useState(rows);
  const [tableRows, setTableRows] = React.useState<IDataTableV2FormattedData[]>(
    []
  );
  const selectedRows = controlledSelectedRows;
  const [selectType, setSelectType] =
    React.useState<IDataTableV2SelectAllCheckedType>(false);
  const isGroupBy = groupBy ? true : false;
  const isGroupByFieldArray = groupBy && groupBy.columnDataType === "array";

  const handleSelectAllRows = (type: IDataTableV2SelectAllCheckedType) => {
    if (onSelection) {
      if (type === "OnlyThisPage") {
        // Remove duplicates by uniqueRowKeyName
        const allRows = [...selectedRows, ...tableRows.filter(x=> !x.disableCheckbox && !x.hideCheckbox)];
        const uniqueRows = allRows.filter(
          (row, index, self) =>
            self.findIndex(
              r => r[uniqueRowKeyName] === row[uniqueRowKeyName]
            ) === index
        );
        onSelection(selectType === "AllPages", uniqueRows);
      } else {
        onSelection(false, []);
      }
      setSelectType(type);
    }
    
  };

  const handleSelectRow =
    (row: IDataTableV2FormattedData) =>
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const updatedRows = [...selectedRows];
      const itemIndex = selectedRows.findIndex(
        (x) => x[uniqueRowKeyName] === row[uniqueRowKeyName]
      );
      if (itemIndex > -1) {
        updatedRows.splice(itemIndex, 1);
        setSelectType(false);
      } else {
        updatedRows.push(row);
      }
      if(onSelection){
          onSelection(selectType === "AllPages", updatedRows);
      }
    };


  const formatData = () => {
    console.log(selectedRows)
    const sortedData = tableV2DataSorting(rows, sortingConfig);
    const data = prepareDataToDataTableV2Format(
      sortedData,
      groupBy,
      detailColumns
    );
    const checkedRows = data.filter((x) => x.isChecked);
    //setSelectedRows(selectedRows);
    setTableRows(data);
    setOriginalRows(sortedData);
  };

  React.useEffect(() => {
    formatData();
  }, [rows, sortingConfig]);

  return {
    tableRows,
    originalRows,
    isGroupBy,
    isGroupByFieldArray,
    selectType,
    selectedRows,
    handleSelectAllRows,
    handleSelectRow,
  };
};
